import React from 'react';


const BurgerMenu = (props) => {
    return (
        <>
            <div className="vertical-line mx-4 h-6 bg-gray-400 hidden lg:block"></div>
            <div className="burger-menu">
                <button 
                    className={`w-10 h-10 flex justify-center items-center  border-solid border-[1px] border-[${props.burgerColor}] rounded-full `}
                    onClick={props.onClick}
                >
                    <img src={props.BurgerBtnImg} alt="Menu" />
                </button>
            </div>
        </>
    );
};

export default BurgerMenu;